export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $api } = useNuxtApp();

  if (process.client && from.fullPath === to.fullPath) {
    return true;
  }

  try {
    const response = await $api.agent.get(`redirect?catchPath=${to.fullPath}`);
    return navigateTo({
      path: response._data.redirect_path
    }, {
      external: response._data.redirect_path.startsWith('http'),
      redirectCode: response._data.redirect_status_code
    });
  } catch (e) {
    console.log(e);
  }
  return true;
});
